import { useState, useCallback } from "react";
import { apiFetch } from "@/lib/api-client";
import type { VerifyConnectionResult } from "../types";

interface UseVerifySiiConnectionResult {
  verify: () => Promise<VerifyConnectionResult>;
  isVerifying: boolean;
  lastResult: VerifyConnectionResult | null;
}

/**
 * Hook to verify SII connection using the configured certificate.
 */
export function useVerifySiiConnection(): UseVerifySiiConnectionResult {
  const [isVerifying, setIsVerifying] = useState(false);
  const [lastResult, setLastResult] = useState<VerifyConnectionResult | null>(
    null,
  );

  const verify = useCallback(async (): Promise<VerifyConnectionResult> => {
    setIsVerifying(true);
    try {
      const result = await apiFetch.post<VerifyConnectionResult>(
        "/api/tax-authority/verify",
        {},
      );
      setLastResult(result);
      return result;
    } finally {
      setIsVerifying(false);
    }
  }, []);

  return {
    verify,
    isVerifying,
    lastResult,
  };
}
